export const isNumberPositive = (value: number | string | null | undefined): boolean =>
    Math.sign(Number(value)) === 1;
